import React from 'react';
import classes from './classes.module.scss';

function Switch({
  id,
  checked,
  onChange,
  offColor = '#ccc',
  onColor = 'var(--app-color)',
  offSliderImg = '',
  onSliderImg = '',
  offSliderColor = '#FFFFFF',
  onSliderColor = '#FFFFFF',
  width = 44,
  height = 22,
  handleDiameter = 18
}) {
  const onCheckBoxChange = (e) => {
    onChange(e.target.checked);
  };

  const renderSwitch = () => (
    <label id={ id } htmlFor={ `checkbox${ id }` } className={ classes.switch } style={ { '--width': `${ width }px`, '--height': `${ height }px` } }>
      <input data-testid="switch-input" id={ `checkbox${ id }` } type="checkbox" checked={ checked } onChange={ onCheckBoxChange } />
      <span
        className={ classes.slider }
        style={ {
          '--offColor': offColor,
          '--onColor': onColor,
          '--offSliderColor': offSliderColor,
          '--onSliderColor': onSliderColor,
          '--offSliderImg': `url(${ offSliderImg })`,
          '--onSliderImg': `url(${ onSliderImg })`,
          '--handleDiameter': `${ handleDiameter }px`
        } }
      />
    </label>
  );

  return renderSwitch();
}

export default Switch;
